import map from '../graph/map';
import mapZoom from '../modules/mapHelper';
import { processRegions } from '../modules/utilsRegions';

let currentHierarchies = null;

function getMapZoom(community, province) {
  const communityId = parseInt(community, 10);
  const provinceId = parseInt(province, 10);
  if (provinceId && mapZoom.communities[communityId] && mapZoom.communities[communityId].provinces[provinceId]) {
    return mapZoom.communities[communityId].provinces[provinceId].zoom;
  }

  if (communityId && mapZoom.communities[communityId]) {
    return mapZoom.communities[communityId].zoom;
  }

  return mapZoom.zoom;
}

function addRegionUrl(recount, level, regions) {
  const currentPortada = recount;

  Object.keys(recount).forEach((regionId) => {
    const result = regions.find((region) => region.id === regionId && region.level === level);
    if (result) {
      currentPortada[regionId].url = result.href;
    }
  });

  return currentPortada;
}

function drawMap(portada) {
  if (portada) {
    const mapToRender = document.getElementById('ac-mostVotedParty').dataset.map;
    let dataToRender = portada.recount;
    let dataLevel = 1;
    const initialView = {
      center: '',
      zoom: 0,
    };

    const boundariesUrl = window.ac_maps_url;
    const useBoundaries = true;

    if (mapToRender === 'index') {
      initialView.zoom = getMapZoom();
      initialView.center = [39.706, -2.644];
    }

    if (mapToRender === 'community') {
      initialView.zoom = getMapZoom(window.ac_community_id);
      dataLevel = 2;
    }

    if (mapToRender === 'province') {
      initialView.zoom = getMapZoom(window.ac_community_id, window.ac_province_id);
      dataLevel = 3;
    }

    dataToRender = addRegionUrl(dataToRender, dataLevel, currentHierarchies);
    const moduleContainer = document.querySelector('[data-controller*="ac-most-voted-party"]');
    if (moduleContainer) {
      const heightModule = moduleContainer.offsetHeight;
      moduleContainer.style.minHeight = `${heightModule}px`;
    }
    map.drawMap('ac-mostVotedParty', dataToRender, boundariesUrl, initialView, useBoundaries, moduleContainer);
  }
}

function drawCurrent() {
  window.dataManager.getPortada().then((portada) => drawMap(portada));
}

function drawPrevious() {
  window.dataManager.getHistoricPortada().then((portada) => drawMap(portada));
}

function changeTab(event) {
  switch (event.currentTarget.dataset.year) {
    case window.ac_labels.percentage_of_votes.current:
      drawCurrent();
      break;

    case window.ac_labels.percentage_of_votes.previous:
      drawPrevious();
      break;

    default:
      throw Error('There is not data for the year selected');
  }
}

function init() {
  if (document.querySelector('[data-controller*="ac-most-voted-party"]')) {
    window.dataManager.getHierarchies().then((hierarchies) => {
      const hierarchiesData = {};

      hierarchiesData[window.ac_election] = hierarchies;
      currentHierarchies = processRegions(
        hierarchiesData,
        window.ac_region_levels,
        window.ac_labels.regions,
      );

      drawCurrent();

      document.querySelector('[data-controller*="ac-most-voted-party"]')
        .querySelectorAll('.ac-tab').forEach((button) => {
          button.addEventListener('click', changeTab);
        });
    });
  }
}

export default init;
